import { useSelector } from 'react-redux';
import {RootState} from "../reducers";

const SUPPORTED_LANGUAGES: Record<string, string[]> = {
  CH: ["de", "fr", "it", "en"],
  DE: ["de"],
  AT: ["de"],
};

export const useAvailableLanguages = (): string[] => {
  const ticket = useSelector((state: RootState) => state.ticket.ticket);

  const isGasStationTicket = ticket?.gasStationZone != null;
  const countryCode = !ticket || Object.keys(ticket).length === 0
    ? "CH"
    : isGasStationTicket
    ? ticket.gasStationZone.countryCode
    : ticket.parkingZone.countryCode;

  return SUPPORTED_LANGUAGES[countryCode] || [];
};
